import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const billGetNextDocumentNumberAtom = createMutationAtomFactory(
  'finance.billGetNextDocumentNumber',
  () => ({
    financeNextBillDocumentNumber: true,
  }),
);
